export const MAX_POST_IMAGE_SIZE = 10 * 1024 * 1024;
export const POST_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];

export const buildCreatePostFormData = (file, caption) => {
  if (!(file instanceof File)) throw new TypeError("A imagem selecionada não é um arquivo válido.");
  const data = new FormData();
  data.append("image", file);
  data.append("caption", caption.trim());
  return data;
};

export const safeFileDiagnostics = (file) => ({
  name: file?.name,
  type: file?.type,
  size: file?.size,
  hasFile: typeof File !== "undefined" && file instanceof File,
});
